
import { 
  getDocs,
  query,
  where,
  orderBy,
  limit as firestoreLimit,
  doc,
  getDoc,
  Firestore 
} from "firebase/firestore";
import { LocationVersion } from "@/types/campLocation";
import { getLocationVersionsRef, getLocationVersionRef } from "./baseVersionService";
import { processVersionData } from "./versionDataProcessor";

export const getLocationVersion = async (
  db: Firestore, 
  versionId: string
): Promise<LocationVersion | null> => {
  try {
    const docRef = getLocationVersionRef(db, versionId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return processVersionData(docSnap);
    }
    return null;
  } catch (error) {
    console.error("Error getting location version:", error);
    throw error;
  }
};

export const getLatestDraftVersion = async (
  db: Firestore, 
  locationId: string
): Promise<LocationVersion | null> => {
  try {
    console.log(`[versionStatusService] Getting latest draft version for location ${locationId}`);
    const versionsRef = getLocationVersionsRef(db);
    const locationRef = doc(db, "campLocations", locationId);
    
    const q = query(
      versionsRef,
      where("locationRef", "==", locationRef),
      where("status", "==", "draft"),
      orderBy("timestamp", "desc"),
      firestoreLimit(1)
    );
    
    console.log(`[versionStatusService] Executing query for latest draft version`);
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      console.log(`[versionStatusService] No draft versions found for location ${locationId}`);
      return null;
    }
    
    const latestDraft = processVersionData(snapshot.docs[0]);
    console.log(`[versionStatusService] Found latest draft version: ${latestDraft.versionId}, status: ${latestDraft.status}, versionNumber: ${latestDraft.versionNumber}`);
    
    return latestDraft;
  } catch (error) {
    console.error("[versionStatusService] Error getting latest draft version:", error);
    throw error;
  }
};

// Add the getLatestLocationVersion function that's imported but was missing
export const getLatestLocationVersion = async (
  db: Firestore, 
  locationId: string
): Promise<LocationVersion | null> => {
  try {
    console.log(`[versionStatusService] Getting latest version for location ${locationId}`);
    const versionsRef = getLocationVersionsRef(db);
    const locationRef = doc(db, "campLocations", locationId);
    
    const q = query(
      versionsRef,
      where("locationRef", "==", locationRef),
      orderBy("timestamp", "desc"),
      firestoreLimit(1)
    );
    
    console.log(`[versionStatusService] Executing query for latest version`);
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      console.log(`[versionStatusService] No versions found for location ${locationId}`);
      return null;
    }
    
    const latestVersion = processVersionData(snapshot.docs[0]);
    console.log(`[versionStatusService] Found latest version: ${latestVersion.versionId}, status: ${latestVersion.status}, versionNumber: ${latestVersion.versionNumber}`);
    
    return latestVersion;
  } catch (error) {
    console.error("[versionStatusService] Error getting latest version:", error);
    throw error;
  }
};

export const getPublishedVersion = async (
  db: Firestore, 
  locationId: string
): Promise<LocationVersion | null> => {
  try {
    const versionsRef = getLocationVersionsRef(db);
    const locationRef = doc(db, "campLocations", locationId);
    
    const q = query(
      versionsRef,
      where("locationRef", "==", locationRef),
      where("status", "==", "published"),
      orderBy("timestamp", "desc"),
      firestoreLimit(1)
    );
    
    const snapshot = await getDocs(q);
    if (snapshot.empty) return null;
    
    return processVersionData(snapshot.docs[0]);
  } catch (error) {
    console.error("Error getting published version:", error);
    throw error;
  }
};
